import React, { useState, useEffect } from 'react';

import { getval2Token } from '../../../Login/Auth';
import { ReserveSOPStep1 } from './ReserveSOPStep1';
import { ReserveSOPStep2 } from './ReserveSOPStep2';


export function ReserveSOP({ id, setIsLoading, isEdit = false }) {
  const [tokenId, setTokenId] = useState("")
  const [resumeId, setResumeId] = useState("")
  const [step, setStep] = useState(1)
  const [content, setContent] = useState(<></>)

  const [customerContractId, setCustomerContractId] = useState("")
  const [customerPositionId, setCustomerPositionId] = useState("")

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("recruitmentContractorStatus", id)
      // console.log(obj)
      setResumeId(obj.resumeId)
      setTokenId(id)
    }
  }, [id])

  useEffect(()=>{
    console.log(resumeId)
    switch (step) {
      case 1:
        setContent(<ReserveSOPStep1 id={id} setIsLoading={setIsLoading} action={choose} />)
        break;
      case 2:
        setContent(<ReserveSOPStep2 id={id} cId={customerContractId} pId={customerPositionId} setIsLoading={setIsLoading} action={init} />)
        break;
    
      default:
        setContent(<></>)
        break;
    }
  },[step, resumeId])

  function init(){
    setStep(1)
    setCustomerContractId("")
    setCustomerPositionId("")
  }

  function choose(step, customerContractId, customerPositionId){
    setStep(step)
    setCustomerContractId(customerContractId)
    setCustomerPositionId(customerPositionId)
  }

  return (
    <>
      {content}
    </>
  )
}

